var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"capturing-state"},[_c('div',{staticClass:"spinner"}),_c('p',[_vm._v("Capturing bug information...")])])
}]

export { render, staticRenderFns }